export default __webpack_public_path__ + "static/media/cycleRickshaw.013d09dc.png";